export default __webpack_public_path__ + "static/media/Folder_alt_duotone_fill.75f5f37c.svg";